const $ = jQuery;
const $window = $(window);
let locations;

// Header Map Popover settings & Initialization
const initHeaderMap = () => {
  const els = once('header-map', '.p-header-map');
  els.forEach((el) => {
    const $this = $(el);
    const wrapper = $this.find('.phm-pins');

    if (!$this.hasClass('p-header-map--international')) {
      // Popover initialization for Germany header map.
      locations = ['wilhelmshaven', 'bremen', 'hamburg', 'wolgast'];

      $.each(locations, function (index, location) {
        $(`#${location}`).popover({
          container: '.p-header-map',
          trigger: 'focus',
          html: true,
          delay: { show: 300, hide: 300 },
          content: wrapper.find(`.${location}-content`),
          placement() {
            if ($(window).width() < 1440) {
              return 'bottom';
            }
            return 'right';
          },
        });
      });
    } else {
      // Popover initialization for Australia header map.
      locations = [
        'adelaide',
        'perth',
        'brunei',
        'bulgaria',
        'rijeka',
        'split',
      ];

      $.each(locations, function (index, location) {
        $(`#${location}`).popover({
          container: '.p-header-map',
          trigger: 'focus',
          html: true,
          placement: 'auto',
          delay: { show: 300, hide: 300 },
          content: wrapper.find(`.${location}-content`),
        });
      });
    }
  });
};

$window.on('load', () => initHeaderMap());
